<p-dialog
        [(visible)]="this.visible"
        [modal]="true"
        [header]="'Physical Sample Firmware Upgrade'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '500px' }"
        (onHide)="this.close()"
>
    <div class="flex flex-col gap-6 my-3">
        <p-ifta-label>
            <p-select
                    (onChange)="onFirmwareUpgradeRequirementSelect($event.value)"
                    [(ngModel)]="this.selectedFirmwareUpgradeRequirement"
                    [options]="firmwareUpgradeRequirements"
                    class="w-full"
                    filter="false"
                    id="selected-firmware-upgrade-requirement">
            </p-select>
            <label for="compatible-sample-hardware-revisions">Requirement For Firmware Upgrade <span
                    class="text-red-500">*</span></label>
        </p-ifta-label>

        @if (this.selectedFirmwareUpgradeRequirement) {
            <p-ifta-label>
                @if (this.selectedFirmwareUpgradeRequirement) {
                    <div>
                        <p-select
                                (onChange)="onFirmwareUpgradeRequirementSelect($event.value)"
                                [(ngModel)]="this.selectedCompatibleFirmwareRevision"
                                [options]="this.compatibleFirmwareRevisions"
                                class="w-full"
                                filter="false"
                                id="compatible-firmware-revision"
                                optionLabel="releaseVersion">
                        </p-select>
                    </div>
                }
                <label for="sample-firmware-revision-release-version">Available Firmware Revision <span
                        class="text-red-500">*</span></label>
            </p-ifta-label>
        }

        @if (this.showFirmwareUpgradeReleaseScopeChooser) {
            <p-ifta-label>
                @if (this.showFirmwareUpgradeReleaseScopeChooser) {
                    <div>
                        <p-select
                                (onChange)="onFirmwareUpgradeReleaseScopeSelect($event.value)"
                                [(ngModel)]="this.selectedFirmwareUpgradeReleaseScope"
                                [options]="firmwareUpgradeReleaseScope"
                                class="w-full"
                                filter="false"
                                id="selected-firmware-upgrade-requirement">
                        </p-select>
                    </div>
                }
                <label for="compatible-sample-hardware-revisions">Release Scope <span
                        class="text-red-500">*</span></label>
            </p-ifta-label>
        }

        @if (this.showCountryChooser) {
            <p-ifta-label>
                @if (this.showCountryChooser) {
                    <div>
                        <p-multi-select
                                [(ngModel)]="this.selectedCountries"
                                [options]="allAvailableCountries"
                                appendTo="body"
                                class="w-full"
                                filter
                                id="selected-firmware-upgrade-requirement"
                                optionLabel="name">
                        </p-multi-select>
                    </div>
                }
                <label for="compatible-sample-hardware-revisions">Dealership Country <span class="text-red-500">*</span></label>
            </p-ifta-label>
        }

        @if (this.showStudioChooser) {
            <p-ifta-label>
                @if (this.showStudioChooser) {
                    <div>
                        <p-multi-select
                                [(ngModel)]="this.selectedStudios"
                                [options]="allAvailableStudios"
                                appendTo="body"
                                class="w-full"
                                filter
                                id="selected-firmware-upgrade-requirement"
                                optionLabel="name">
                        </p-multi-select>
                    </div>
                }
                <label for="compatible-sample-hardware-revisions">Studio <span class="text-red-500">*</span></label>
            </p-ifta-label>
        }

        <p-ifta-label>
            <p-select
                    (onChange)="onFirmwareUpgradeReleaseWindowSelect($event.value)"
                    [(ngModel)]="this.selectedFirmwareUpgradeReleaseWindow"
                    [options]="firmwareUpgradeReleaseWindow"
                    class="w-full"
                    filter="false"
                    id="selected-firmware-upgrade-installation-window">
            </p-select>
            <label for="compatible-sample-hardware-revisions">Firmware Insttalation Window <span
                    class="text-red-500">*</span></label>
        </p-ifta-label>

        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>
    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="this.close()"
                severity="secondary"
        ></p-button>
        <p-button
                [label]="this.preSelectAll ? 'View Samples' : 'Choose Samples'"
                icon="pi pi-check"
                (click)="this.choosePhysicalSamples()"
                [disabled]="this.choosePhysicalSamplesDisabled"
                [loading]="this.loading"
        ></p-button>
    </div>
</p-dialog>